import { mapToCamelCase } from '../../helpers/helpers';
import { axios } from '../../core/AxiosInterceptor/AxiosInterceptor';
import { ErrorResponse } from '@partnerconnect-monorepo/types/ErrorResponse';
import {
  APIHelpSection,
  UpdateHelpSectionParams
} from '@partnerconnect-monorepo/types/HelpSection';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

const updateHelpSection = (id: number, params: UpdateHelpSectionParams) =>
  axios
    .put(`/help-sections/${id}/`, params)
    .then<APIHelpSection>(({ data }) => mapToCamelCase(data));

export const useUpdateHelpSection = (
  id: number,
  options: UseMutationOptions<
    APIHelpSection,
    AxiosError<ErrorResponse>,
    UpdateHelpSectionParams
  > = {}
) =>
  useMutation({
    mutationFn: (params) => updateHelpSection(id, params),
    ...options
  });
